import React from "react";
import { EmblaCarousel } from "../EmblaCarousel";
import {
  ProjectUpdateSlide,
  ProjectUpdateSlideProps,
} from "../ProjectUpdateSlide";
import { useIsTabletUp } from "../utils/use-media-breakpoints";

export type ProjectUpdatesCarouselProps = {
  data: ProjectUpdateSlideProps[];
};

export const ProjectUpdatesCarousel = ({
  data,
}: ProjectUpdatesCarouselProps) => {
  const slides = data
    .slice(0, 7)
    .map((projectUpdate: ProjectUpdateSlideProps, index: number) => {
      return (
        <ProjectUpdateSlide
          key={index}
          title={projectUpdate.title}
          date={projectUpdate.date}
          description={projectUpdate.description}
          projectUrl={projectUpdate.projectUrl}
          image={projectUpdate.image}
          projectLocation={projectUpdate.projectLocation}
        />
      );
    });

  return useIsTabletUp() ? (
    <EmblaCarousel arrowNavigation infiniteLoop slides={slides} />
  ) : (
    <EmblaCarousel arrowNavigation slides={slides} />
  );
};
